import { History, Workflow } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { WORKFLOW_PERMISSIONS } from '@/lib/permissions'

import { workflowEditorRoute, workflowRunRoute, workflowRunsRoute, workflowsRoute } from './routes'

export const workflowsModule = defineModule({
  routes: [workflowsRoute, workflowEditorRoute, workflowRunsRoute, workflowRunRoute],
  sections: {
    dataCollection: [{ id: 'workflows', label: 'Workflows', order: 40 }],
  },
  navigation: {
    dataCollection: [
      {
        to: '/$entityId/workflows',
        label: 'Workflows',
        icon: Workflow,
        permission: WORKFLOW_PERMISSIONS.read,
        section: 'workflows',
        order: 10,
      },
      {
        to: '/$entityId/workflow-runs',
        label: 'Workflow runs',
        icon: History,
        permission: WORKFLOW_PERMISSIONS.read,
        section: 'workflows',
        order: 20,
      },
    ],
  },
})
